function initAccordion() {
    document.querySelectorAll('.accordion-header').forEach(button => {
      if (button.dataset.accordionBound) return; 
  
      button.dataset.accordionBound = true;
      button.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
  
        const content = this.nextElementSibling;
        const icon = this.querySelector(".icon");
        const isOpen = content.style.display === "block";
  
        content.style.display = isOpen ? "none" : "block";
        icon.classList.toggle("up", !isOpen);
        icon.classList.toggle("down", isOpen);
  
        this.setAttribute("aria-expanded", !isOpen);
        content.setAttribute("aria-hidden", isOpen);
      });
    });
  }
  
document.addEventListener("DOMContentLoaded", initAccordion);

document.addEventListener("shopify:section:load", initAccordion);
  
document.addEventListener("DOMContentLoaded", function () {
  const branchSelects    = document.querySelectorAll('select[name="attributes[Branch]"]');
  const occasionSelects  = document.querySelectorAll('select[name="attributes[Occasions]"]');
  const messageTextareas = document.querySelectorAll('textarea[name="attributes[message]"]');
  const noteTextareas    = document.querySelectorAll('textarea[name="note"]');
  //const gateCodeInputs   = document.querySelectorAll('input[name="attributes[GateCode]"]'); 
  const contactFields    = document.querySelectorAll('input[name="attributes[Contact Number]"]');
  const smsCheckboxes = document.querySelectorAll('input[name="attributes[SMS Consent]"]');
  //const policyCheckboxes = document.querySelectorAll('input[name="attributes[Policy Consent]"]');




  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const currentBranch     = cart.attributes?.Branch || "";
      const currentOccasions   = cart.attributes?.Occasions || "";
      const currentMessage    = cart.attributes?.message || "";
      const currentNote       = cart.note || "";
      //const currentGateCode   = cart.attributes?.GateCode || "";
      const currentContactNum = cart.attributes?.["Contact Number"] || "";
      //const currentPolicyConsent = cart.attributes?.["Policy Consent"] === "Agreed";


      branchSelects.forEach(select => {
        if (select) select.value = currentBranch;
      });

      occasionSelects.forEach(select => {
        if (select) select.value = currentOccasions;
      });

      messageTextareas.forEach(textarea => {
        if (textarea) textarea.value = currentMessage;
      });

      noteTextareas.forEach(textarea => {
        if (textarea) textarea.value = currentNote;
      });

      //gateCodeInputs.forEach(input => {
      //  if (input) input.value = currentGateCode;
      //});

      contactFields.forEach(input => {
        if (input) input.value = currentContactNum;
      });

      //policyCheckboxes.forEach(checkbox => {
        //if (checkbox) checkbox.checked = currentPolicyConsent;
      //});

    });



  // Save Policy Consent when checkbox changes
  // policyCheckboxes.forEach(checkbox => {
   // if (checkbox) {
    //  checkbox.addEventListener("change", function () {
    //   const value = checkbox.checked ? "Agreed" : "";
    //   const formData = new FormData();
    //   formData.append("attributes[Policy Consent]", value);

    //    fetch("/cart/update.js", {
    //      method: "POST",
    //      body: formData,
    //   })
    //    .then(() => {
    //      policyCheckboxes.forEach(el => el.checked = checkbox.checked);
    //    })
    //    .catch(err => console.error("Policy Consent update failed", err));
    //  });
  //  }
  // });
  
    occasionSelects.forEach(select => {
    if (select) {
      select.addEventListener("change", function () {
        const value = select.value;
        const formData = new FormData();
        formData.append("attributes[Occasions]", value);

        fetch("/cart/update.js", {
          method: "POST",
          body: formData,
        }).then(() => {
          occasionSelects.forEach(el => el.value = value);
        }).catch(err => console.error("Occasions update failed", err));
      });
    }
  });



  branchSelects.forEach(select => {
    if (select) {
      select.addEventListener("change", function () {
        const value = select.value;
        const formData = new FormData();
        formData.append("attributes[Branch]", value);

        fetch("/cart/update.js", {
          method: "POST",
          body: formData,
        }).then(() => {
          branchSelects.forEach(el => el.value = value);
        }).catch(err => console.error("Branch update failed", err));
      });
    }
  });



  messageTextareas.forEach(textarea => {
    if (textarea) {
      textarea.addEventListener("blur", function () {
        const value = textarea.value;
        const formData = new FormData();
        formData.append("attributes[message]", value);

        fetch("/cart/update.js", {
          method: "POST",
          body: formData,
        }).then(() => {
          messageTextareas.forEach(el => el.value = value);
        }).catch(err => console.error("Message update failed", err));
      });
    }
  });

  noteTextareas.forEach(textarea => {
    if (textarea) {
      textarea.addEventListener("blur", function () {
        const value = textarea.value;
        const formData = new FormData();
        formData.append("note", value);

        fetch("/cart/update.js", {
          method: "POST",
          body: formData,
        }).then(() => {
          noteTextareas.forEach(el => el.value = value);
        }).catch(err => console.error("Note update failed", err));
      });
    }
  });

  //gateCodeInputs.forEach(input => {
  //  if (input) {
  //    input.addEventListener("blur", function () {
  //      const value = input.value;
  //      const formData = new FormData();
  //      formData.append("attributes[GateCode]", value);

  //      fetch("/cart/update.js", {
  //        method: "POST",
  //        body: formData,
  //      }).then(() => {
  //        gateCodeInputs.forEach(el => el.value = value);
  //      }).catch(err => console.error("GateCode update failed", err));
  //    });
  //  }
  //});

  contactFields.forEach(input => {
    if (input) {
      input.addEventListener("blur", function () {
        const value = input.value;
        const formData = new FormData();
        formData.append("attributes[Contact Number]", value);

        fetch("/cart/update.js", {
          method: "POST",
          body: formData,
        }).then(() => {
          contactFields.forEach(el => el.value = value);
        }).catch(err => console.error("Contact Number update failed", err));
      });
    }
  });


  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const currentConsent = cart.attributes?.["SMS Consent"] === "Agreed";
      smsCheckboxes.forEach(checkbox => {
        if (checkbox) checkbox.checked = currentConsent;
      });
    });


  smsCheckboxes.forEach(checkbox => {
    if (checkbox) {
      checkbox.addEventListener("change", function () {
        const value = checkbox.checked ? "Agreed" : "";
        const formData = new FormData();
        formData.append("attributes[SMS Consent]", value);

        fetch("/cart/update.js", {
          method: "POST",
          body: formData,
        })
        .then(() => {
          smsCheckboxes.forEach(el => el.checked = checkbox.checked);
        })
        .catch(err => console.error("SMS Consent update failed", err));
      });
    }
  });


});




function getFormattedToday() {
  const today = new Date();
  return `${String(today.getMonth() + 1).padStart(2, '0')}/${String(today.getDate()).padStart(2, '0')}/${today.getFullYear()}`;
}

function updateCartAttributeDate(dateStr) {
  return fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: { date: dateStr } })
  }).then(res => res.json());
}

function syncAllDatePickers(dateStr, sourceInput) {
  document.querySelectorAll('.delivery-date-input').forEach(input => {
    if (input !== sourceInput && input._flatpickr) {
      const currentDate = input._flatpickr.input.value;

      if (currentDate !== dateStr) {
        input._flatpickr.setDate(dateStr, true);
      }
    }
  });
}


function initDeliveryDatePickers() {
  const inputs = document.querySelectorAll('.delivery-date-input');
  const nationwideItems = document.getElementsByClassName("nationwide");
  const today = getFormattedToday();
  const cartDate = Shopify?.cart?.attributes?.date || inputs[0]?.value || today;

  if (!Shopify?.cart?.attributes?.date) {
    updateCartAttributeDate(cartDate).then(() => {
      syncAllDatePickers(cartDate, null);
    });
  }

  inputs.forEach(input => {
    if (input.classList.contains('flatpickr-applied')) return;

    const flatpickrOptions = {
      dateFormat: "m/d/Y",
      defaultDate: cartDate,
      minDate: "today",
      maxDate: new Date(new Date().setMonth(new Date().getMonth() + 2)),
      disableMobile: true,
      onChange: function (selectedDates, dateStr) {
        updateCartAttributeDate(dateStr).then(() => {
          syncAllDatePickers(dateStr, input);
        });
      }
    };

    if (nationwideItems.length > 0) {
      flatpickrOptions.disable = [
        function(date) {
          const day = date.getDay();
          return day === 0 || day === 1 || day === 2;
        }
      ];
    }

    flatpickr(input, flatpickrOptions);
    input.classList.add('flatpickr-applied');
  });
}

function setupCheckoutValidation() {
    function bindValidation() {
        const dateInputs = document.querySelectorAll(".delivery-date-input");
        const checkoutButtons = document.querySelectorAll(".cart-checkout");
        const orchidButton = document.getElementById("checkout-btn-orchid");
        //const contactInput = document.querySelector('input[name="attributes[Contact Number]"]');
        //const smsCheckbox = document.querySelector('input[name="attributes[SMS Consent]"]');
        //const policyCheckbox = document.querySelector('input[name="attributes[Policy Consent]"]'); // ✅ Added
        const notificationBoxes = document.querySelectorAll(".cart-validation-msg");

        function validate() {
            let messages = [];

            // ✅ Delivery Date validation
            const dateVal = Array.from(dateInputs).pop()?.value?.trim();
            let validDate = false;
            if (dateVal) {
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                const selected = new Date(dateVal);
                validDate = selected >= today;
            }
            if (!validDate) messages.push("Please select a valid delivery date.");

            // ✅ Contact Number validation
            //const contactNumber = contactInput?.value.trim() || "";
            //const normalizedNumber = contactNumber.replace(/[\s\-\(\)]/g, "");

            //if (!normalizedNumber) {
            //    messages.push("Please enter your contact number.");
            // } else if (!/^(\+1)?\d{10}$/.test(normalizedNumber)) {
            //    messages.push("Please enter a valid US phone number (10 digits, optional +1).");
            //}

            // ✅ SMS Consent validation
            //if (!smsCheckbox?.checked) {
            //    messages.push("Please agree to receive order updates via SMS.");
            //}

            // ✅ Policy Consent validation
            //if (!policyCheckbox?.checked) {
                //messages.push("Please confirm you have read and accepted the Return, Refund, and Exchange Policy.");
            //}

            // ✅ Enable/Disable checkout buttons
            const isValid = messages.length === 0;
            checkoutButtons.forEach(btn => btn.classList.toggle("cart-instructions__checkout--disabled", !isValid));
            orchidButton?.classList.toggle("cart-instructions__checkout--disabled", !isValid);

            // ✅ Show messages
            notificationBoxes.forEach(box => {
                if (messages.length > 0) {
                    box.innerHTML = messages.join("<br/>");
                    box.style.display = "block";
                } else {
                    box.innerHTML = "";
                    box.style.display = "none";
                }
            });
        }

        // Event bindings
        dateInputs.forEach(input => input.addEventListener("input", validate));
        //contactInput?.addEventListener("input", validate);
        //contactInput?.addEventListener("change", validate);
        //contactInput?.addEventListener("blur", validate);
        //smsCheckbox?.addEventListener("input", validate);
        //smsCheckbox?.addEventListener("change", validate);
        // policyCheckbox?.addEventListener("input", validate);
        // policyCheckbox?.addEventListener("change", validate);

        validate();
    }

    document.addEventListener("shopify:section:load", bindValidation);
    document.addEventListener("shopify:section:reorder", bindValidation);
    document.addEventListener("shopify:section:select", bindValidation);
    document.addEventListener("shopify:section:deselect", bindValidation);

    bindValidation();
}


document.addEventListener("DOMContentLoaded", setupCheckoutValidation);

document.addEventListener('DOMContentLoaded', () => {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      Shopify = Shopify || {};
      Shopify.cart = cart;
      initDeliveryDatePickers();
      setupCheckoutValidation();
    });
});

const drawer = document.getElementById('cart-drawer');
if (drawer) {
  new MutationObserver(() => {
    initDeliveryDatePickers();
    setupCheckoutValidation();
  }).observe(drawer, { childList: true, subtree: true });
}


document.addEventListener("DOMContentLoaded", function () {
  const stickyElement = document.querySelector(".collection-header");
  const sentinel = document.querySelector(".sticky-sentinel");

  if (!stickyElement || !sentinel) return;

  const triggerPoint = sentinel.offsetTop; // when sticky should activate
  let isSticky = false;

  window.addEventListener("scroll", function () {
    const scrollY = window.scrollY || window.pageYOffset;

    if (scrollY > triggerPoint + 50 && !isSticky) {
      // Add sticky
      isSticky = true;
      stickyElement.classList.add("is-sticky");
      document.querySelector(".filter-toggle")?.classList.remove("hidden");
      stickyElement.classList.add("content-hidden");
      document.querySelector(".collection-header-content")?.classList.add("hidden");
      document.querySelector(".collection__filters--active")?.classList.add("hidden");
    } 
    else if (scrollY <= triggerPoint + 50 && isSticky) {
      // Remove sticky
      isSticky = false;
      stickyElement.classList.remove("is-sticky");
      document.querySelector(".filter-toggle")?.classList.add("hidden");
      stickyElement.classList.remove("content-hidden");
      document.querySelector(".collection-header-content")?.classList.remove("hidden");
      document.querySelector(".collection__filters--active")?.classList.remove("hidden");
    }
  });
});


  document.addEventListener('DOMContentLoaded', function () {
    const backToTopButton = document.getElementById('back-to-top');

    window.addEventListener('scroll', () => {
      if (window.pageYOffset > 1000) {
        backToTopButton.style.display = 'block';
      } else {
        backToTopButton.style.display = 'none';
      }
    });

    backToTopButton.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  });
